var u = Object.freeze, E = Object.defineProperty;
var s = (r, e) => u(E(r, "raw", { value: u(e || r.slice()) }));
import { d as S } from "./exportparts-Bjal6DGN.js";
import { L as C } from "./lds-form-element-0ncM0Cyi.js";
import { i as N, x as d } from "./lit-element-CwWchyls.js";
import { n as l } from "./property-EvzlnPW3.js";
import { r as h } from "./state-D88UmDIj.js";
import { e as c } from "./query-Dk6NwgU8.js";
import { o as k } from "./query-assigned-elements-Wf_N7Qhp.js";
import { e as f } from "./class-map-CiBNip0q.js";
import "./lds-dropdown.js";
import "./lds-icon.js";
import { o as M } from "./if-defined-BopGAQiw.js";
import { e as P, a as T } from "./context-D-64zexR.js";
var b;
const z = N(b || (b = s(["\n    :host {\n        display: inline-block;\n        width: 100%;\n        position: relative;\n    }\n\n    lds-dropdown {\n        width: 100%;\n    }\n\n    .trigger {\n        border-color: transparent;\n        border-width: var(--lds-input-border-width);\n        border-style: solid;\n        border-radius: var(--lds-input-border-radius);\n        height: var(--lds-input-height-md);\n        background: var(--lds-color-default-20);\n        color: var(--lds-text);\n        font-weight: normal;\n        display: flex;\n        align-items: center;\n        padding: 0 var(--lds-spacing-md);\n        box-sizing: border-box;\n        position: relative;\n    }\n\n    .trigger.read-only {\n        opacity: 0.5;\n        cursor: text;\n    }\n\n    /** native select */\n    select {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        outline: none;\n        width: 100%;\n        border: none;\n        color: transparent;\n        right: 0;\n        appearance: none;\n        background: transparent;\n        cursor: pointer;\n    }\n\n    option {\n        color: var(--lds-text);\n    }\n\n    /** hide options on mobile when the native select is used */\n    .options.options-hidden-mobile {\n        display: none;\n    }\n\n    /** when device has hover hide the native select and show the options even if they should be hidden via mobile native */\n    @media (hover: hover) {\n        select {\n            display: none;\n        }\n\n        .options.options-hidden-mobile {\n            display: unset;\n        }\n    }\n\n    .options {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n    }\n\n    label {\n        display: block;\n        font-weight: bold;\n    }\n\n    input {\n        position: absolute;\n        opacity: 0;\n        padding: 0;\n        margin: 0;\n        pointer-events: none;\n    }\n\n    .rotate-180 {\n        transform: rotateZ(180deg);\n    }\n\n    lds-icon {\n        margin-left: auto;\n    }\n\n    lds-dropdown::part(dropdown) {\n        width: max-content;\n        max-width: var(--dropdown-max-width);\n        min-width: 100%;\n        max-height: var(--lds-dropdown-max-height);\n    }\n\n    .has-error {\n        border-color: var(--lds-color-error);\n        border-width: var(--lds-input-border-width);\n        border-style: solid;\n    }\n\n    .error {\n        color: var(--lds-color-error);\n        font-size: var(--lds-font-size-xs);\n        line-height: var(--lds-font-size-sm);\n        padding-top: 4px;\n    }\n\n    .error-wrapper {\n        min-height: 18px;\n    }\n"])));
var A = Object.defineProperty, i = (r, e, t, n) => {
  for (var a = void 0, p = r.length - 1, m; p >= 0; p--)
    (m = r[p]) && (a = m(e, t, a) || a);
  return a && A(e, t, a), a;
}, g, y, w, x, $;
const v = class v extends C {
  constructor() {
    var e;
    super(...arguments), this.required = !1, this.value = "", this.label = "", this.selectedOption = null, this.context = {
      setActive: (t, n = !0) => {
        this.value = t.value, this.selectedOption = t, this.context = { ...this.context, activeOption: t.uuid }, n && this.emit("change", { option: t });
      },
      activeOption: (e = this.selectedOption) == null ? void 0 : e.uuid
    }, this.nativeMobile = !1, this.readOnly = !1, this.open = !1, this.role = "listbox";
  }
  get validationElement() {
    return this.input;
  }
  onDropdownChange(e) {
    if (this.readOnly) {
      e.target.open = !1;
      return;
    }
    this.open = e.detail;
  }
  firstUpdated() {
    this.setAttribute("aria-label", this.label), this.addEventListener("click", (e) => {
      e.composedPath()[0] === this && this.dropdownElement.onClick();
    });
  }
  willUpdate(e) {
    if (e.has("value")) {
      const t = Array.from(this.options).find((n) => n.value === this.value);
      t && this.context.setActive(t, !1);
    }
  }
  onSlotChange() {
    this.options.forEach((e) => {
      e.selected && (this.emit("change", { option: e }), this.context.setActive(e, !1));
    }), this.nativeMobile && this.addOptionsToNativeSelect();
  }
  addOptionsToNativeSelect() {
    this.nativeSelect.innerHTML = "";
    const e = document.createElement("option");
    e.hidden = !0, this.nativeSelect.appendChild(e), this.options.forEach((t) => {
      const n = document.createElement("option");
      n.value = t.value, n.innerText = t.innerText, this.nativeSelect.appendChild(n);
    });
  }
  onNativeSelectChange(e) {
    const t = e.target;
    this.value = t.value, this.emit("change");
  }
  render() {
    var e;
    return d($ || ($ = s(["\n            ", '\n            <input type="text" ?required=', ' tabindex="-1" .value=', ' id="input" />\n            <lds-dropdown\n                id="dropdown"\n                @change=', '\n                part="dropdown"\n                exportparts="', '">\n                <div\n                    class="trigger ', '"\n                    slot="trigger"\n                    part="trigger">\n                    ', '\n                    <slot name="selected" part="selected">\n                        <span>', '</span>\n                    </slot>\n                    <lds-icon\n                        part="icon"\n                        name="chevron-down"\n                        class="', '"></lds-icon>\n                </div>\n                <div class="options ', '" part="options">\n                    <slot @slotchange=', '></slot>\n                </div>\n            </lds-dropdown>\n            <div class="error-wrapper" part="error-wrapper">\n                ', "\n                ", "\n            </div>\n        "])), M(this.label) ? d(g || (g = s(['<label part="label" id="label">', "</label>"])), this.label) : "", this.required, this.value, this.onDropdownChange, S("dropdown"), f({ "has-error": this.hasError, "read-only": this.readOnly }), this.nativeMobile ? d(y || (y = s(['<select @change="', '" .value=', "></select>"])), this.onNativeSelectChange, this.value) : "", (e = this.selectedOption) == null ? void 0 : e.getTextLabel(), f({
      "rotate-180": this.open
    }), this.nativeMobile ? "options-hidden-mobile" : "", this.onSlotChange, this.currentValidationErrors.map((t) => d(w || (w = s(['<div class="error">', "</div>"])), t)), this.errors.map((t) => d(x || (x = s(['<div class="error">', "</div>"])), t)));
  }
};
v.styles = z;
let o = v;
i([
  l({ type: Boolean, reflect: !0 })
], o.prototype, "required");
i([
  l({ type: String })
], o.prototype, "value");
i([
  l({ type: String })
], o.prototype, "label");
i([
  h()
], o.prototype, "selectedOption");
i([
  P({ context: T }),
  h()
], o.prototype, "context");
i([
  c("input")
], o.prototype, "input");
i([
  c("select")
], o.prototype, "nativeSelect");
i([
  l({ type: Boolean, attribute: "native-mobile" })
], o.prototype, "nativeMobile");
i([
  l({ type: Boolean, attribute: "read-only" })
], o.prototype, "readOnly");
i([
  h()
], o.prototype, "open");
i([
  l({ type: String, reflect: !0 })
], o.prototype, "role");
i([
  k({ selector: "lds-option" })
], o.prototype, "options");
i([
  c("lds-dropdown")
], o.prototype, "dropdownElement");
const O = new URL(import.meta.url), R = O.searchParams.has("debug");
if (!O.searchParams.has("no-define")) {
  const r = customElements.get("lds-select");
  r ? r.VERSION !== o.VERSION && R && console.log("%clds-select tried loading in version ".concat(o.VERSION, ", but lds-select is already defined as ").concat(r.VERSION), "font-weight: bold; font-size: 16px; color: red;") : customElements.define("lds-select", o);
}
export {
  o as LdsSelect
};
